module.exports = "//cdn-deploy.cdn.bcebos.com/muses_plt/static/img/4.2-publish-service.7ede803f.png";